export default function columnImg() {
  const imgBlock = document.querySelector('.column__article-inner')
  const images = imgBlock.querySelectorAll('img')
  images.forEach(img => {
    const width = img.getAttribute('width')
    if (width) {
      const divisor = window.innerWidth >= 769 ? 12.8 : 3.9
      img.style.width = `calc(${width}vw / ${divisor})`
      img.classList.add('responsive-img')
    }
  })
}
